import { render, staticRenderFns } from "./SendMailable.vue?vue&type=template&id=810e4a8a&scoped=true&"
import script from "./SendMailable.vue?vue&type=script&lang=js&"
export * from "./SendMailable.vue?vue&type=script&lang=js&"
import style0 from "./SendMailable.vue?vue&type=style&index=0&id=810e4a8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e4a8a",
  null
  
)

export default component.exports